import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, Http, RequestOptions } from '@angular/http';

import { LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';
import { LaddaModule } from 'angular2-ladda';
// import { LoadingModule } from 'ngx-loading';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { LoaderModule } from './shared/loader/loader.module';

// Routing Module
import { AppRoutingModule } from './app.routing';
import { JwtHelper, AuthHttp, AuthConfig } from 'angular2-jwt';
import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { RoleGuardService } from './auth/role-guard.service';

// API Service
import { BonusTemplateApiService } from '../data/BonusTemplateApi.service';
import { BonusCalculationApiService } from '../data/BonusCalculationApi.service';
import { DashboardApiService } from '../data/DashboardApi.service';
import { DownloadMonthlyApiService } from '../data/DownloadMonthlyApi.service';
import { FinalBonusApiService } from '../data/FinalBonusApi.service';
import { GeneralApiService } from '../data/GeneralApi.service';
import { HomeApiService } from '../data/HomeApi.service';
import { MapBonusTemplateApiService } from '../data/MapBonusTemplateApi.service';
import { MonthlyReportApiService } from '../data/MonthlyReportApi.service';
import { UserManagementRoleApiService } from '../data/UserManagementRoleApi.service';
import { VerifyBonusCalculationApiService } from '../data/VerifyBonusCalculationApi.service';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout.component';

import { CallbackComponent } from './callback/callback.component';
import { InvalidPageComponent } from './misc/invalid-page/invalid-page.component';
// import { LoadingComponent } from 'ngx-loading/src/ngx-loading.component';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({}), http, options);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    FormsModule,
    ChartsModule,
    LaddaModule,
    // LoadingModule,
    ReactiveFormsModule,
    LoaderModule
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    BlankLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    CallbackComponent,
    InvalidPageComponent 
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    
    // Auth Service
    { provide: AuthHttp, useFactory: authHttpServiceFactory, deps: [Http, RequestOptions] },
    AuthService, 
    AuthGuardService, 
    RoleGuardService,
    JwtHelper, 
    
    // BODES API Services
    BonusCalculationApiService,
    BonusTemplateApiService, 
    DashboardApiService,
    DownloadMonthlyApiService,
    FinalBonusApiService,
    GeneralApiService,
    HomeApiService,
    MapBonusTemplateApiService, 
    MonthlyReportApiService,
    UserManagementRoleApiService,
    VerifyBonusCalculationApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/app.module.ts